import Component from "vue-class-component";
import Vue from "Vue";
import { Prop } from "vue-property-decorator";
import { Color } from "../../models/color";

@Component
export default class Pill extends Vue {
	@Prop({ default: "" })
	public title;

	@Prop({ default: "" })
	public icon;

	@Prop({ default: "" })
	public text;

	@Prop({ default: "" })
	public color;

	@Prop({ default: false })
	public disabled;

	public isRedColor(): boolean {
		return (this.color === Color[Color.Red].toLowerCase());
	}

	public isGreenColor(): boolean {
		return (this.color.toLowerCase() === Color[Color.Green].toLowerCase());
	}

	public isBlueColor(): boolean {
		return (this.color.toLowerCase() === Color[Color.Blue].toLowerCase());
	}

	public isOrangeColor(): boolean {
		return (this.color.toLowerCase() === Color[Color.Orange].toLowerCase());
	}

	public isGreyColor(): boolean {
		return (this.color.toLowerCase() === Color[Color.Grey].toLowerCase());
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/Pill/Pill.ts